import { createFileRoute } from '@tanstack/react-router';
import { evidenceLineQuery } from '../../api/evidence.ts';
import { EvidenceLinePage } from '../../features/evidence/line-page.tsx';
import { isLineCode, validateLineSearch } from '../../features/evidence/search.ts';

// Evidence line page (T26). `?asOf=` shows an earlier day, `?freeze=` the frozen record (T32).
export const Route = createFileRoute('/_authed/evidence/$code')({
  validateSearch: validateLineSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, params, deps }) => {
    if (isLineCode(params.code) && deps.freeze === undefined) {
      void context.queryClient.prefetchQuery(evidenceLineQuery(params.code, deps.asOf));
    }
  },
  component: LineRoute,
});

function LineRoute(): React.JSX.Element {
  const { code } = Route.useParams();
  const { asOf } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <EvidenceLinePage
      key={code}
      code={code}
      asOf={asOf}
      onAsOf={(next) => void navigate({ search: { asOf: next } })}
    />
  );
}
